module.exports = __webpack_public_path__ + "static/img/pano.9150549f.jpg";